class PaidTravelerAncillaryUIModel {
  constructor({
    commercialName = null,
    emdConsummedAtIssuance = null,
    groupCode = null,
    legCode = null,
    qrcode = null,
    quantity = null,
    redeemed = null,
    redeemedCorporate = null,
    rficSubcode = null,
    segmentCodeAux = null,
    type = null,
    used = null,
  } = {}) {
    this.commercialName = commercialName;
    this.emdConsummedAtIssuance = emdConsummedAtIssuance;
    this.groupCode = groupCode;
    this.isPaid = true;
    this.legCode = legCode;
    this.qrcode = qrcode;
    this.quantity = redeemedCorporate ? 1 : quantity;
    this.redeemed = redeemed;
    this.redeemedCorporate = redeemedCorporate;
    this.rficSubcode = rficSubcode;
    this.segmentCodeAux = segmentCodeAux;
    this.type = type;
    this.used = used;
  }

  getType() {
    return this.type === '029' ? 'CBX' : this.type;
  }

  getGroupCode() {
    return this.groupCode;
  }

  toApi() {
    return {
      '_meta':{
        'class':'PaidTravelerAncillary',
      },
      'quantity': this.quantity,
      'type': this.type,
      'options': [],
      'legCode': this.legCode,
      'groupCode': this.groupCode,
      'used': this.used,
      'commercialName': this.commercialName,
      'emdConsummedAtIssuance': this.emdConsummedAtIssuance,
    };
  }
}

export default PaidTravelerAncillaryUIModel;
